/*
Author: Vaishnavi
Date: 26/11/2019
Issue Description: Commented module name headers
*/
<template>
  <div>
    <div>
      <tl-header type="h1">
        <div>Statutory Info</div>
        <template slot="icon">
          <div class="showIntro" @click="goToIntro">
            <img src="@/assets/questionmark.png" />
          </div>
        </template>
      </tl-header>
      <div>
        <!-- ['PF', 'IT', 'Gratuity','Form 16', 'Form 24' ] -->
        <tl-stepper
          :heading="['PF', 'IT', 'Gratuity']"
          :current="current"
          @currentStepper="goToStep(0)"></tl-stepper>

        <div v-if="pfSettings">
          <pf-settings
              @skip="goToStep(1)"
              @previous="prevPf"
              @next="goToStep(1)"
          />
        </div>

        <div v-if="showIt">
          <income
              @skip="goToStep(2)"
              @previous="goToStep(0)"
              @next="goToStep(2)"
          />
        </div>

        <div v-if="gratuity">
          <gratuity
              @skip="goToDepartments"
              @previous="goToStep(1)"
              @next="goToDepartments"
          />
        </div>

        <!-- <div v-if="showForm">
          <form-sixteen
              @skip="goToStep(4)"
              @previous="goToStep(2)"
              @next="goToStep(4)"
          />
        </div>

        <div v-if="showForm24">
          <form-twenty-four
            @skip="goToDepartments"
            @previous="goToStep(3)"
            @next="goToDepartments"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import PfSettings from "@/modules/onboarding/views/pages/le-level/statutory/PF_Settings.vue";
import TlStepper from "@/components/stepper/TlStepper.vue";
import Income from "@/modules/onboarding/views/pages/le-level/statutory/Income.vue";
import Gratuity from "@/modules/onboarding/views/pages/le-level/statutory/Gratuity.vue";
// import FormSixteen from "./form16.vue";
// import FormTwentyFour from "./form24.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "Statutory",
  components: {
    PfSettings,
    TlStepper,
    Income,
    // FormSixteen,
    Gratuity,
    // FormTwentyFour
  },
  data() {
    return {
      registeredPF: false,
      pfSettings: true,
      registerPF: true,
      current: 0,
      showIt: false,
      // showForm: false,
      gratuity: false,
      // showForm24: false,
    };
  },
  activated: function() {
    this.current = 0;
    this.pfSettings = true;
    this.showIt = false;
    this.gratuity = false;
    // this.showForm = false;
    // this.showForm24 = false;
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getdata: "onboard/statutory/getData"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
        return this.getleid(0);
      }
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    }
  },
  methods: {
    ...mapActions("onboard/statutory/", {
      act_fetchAll: "fetchAll",
      act_create: "create"
    }),
    goToStep(currentVal) {
      if (!currentVal || currentVal < 0 || currentVal > 4) {
        currentVal = 0;
      }
      this.pfSettings = false;
      this.showIt = false;
      this.gratuity = false;
      // this.showForm = false;
      // this.showForm24 = false;
      this.current = currentVal;

      if(currentVal == 0) {
        this.pfSettings = true;
      }
      if(currentVal == 1) {
        this.showIt = true;
      }
      if(currentVal == 2) {
        this.gratuity = true;
      }
      // if(currentVal == 3) {
      //   this.showForm = true;
      // }
      // if(currentVal == 4) {
      //   this.showForm24 = true;
      // }
    },
    goToIntro() {
      this.$emit("displayIntro");
    },
    prevPf() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/locations`
      });
    },
    goToDepartments() {
      // this.showForm24 = false;
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/departments`
      );
    }
  }
};
</script>

<style scoped>
.showIntro {
  cursor: pointer;
}
</style>
